import { render, staticRenderFns } from "./add-contact.vue?vue&type=template&id=72277943"
import script from "./add-contact.vue?vue&type=script&lang=ts"
export * from "./add-contact.vue?vue&type=script&lang=ts"
import style0 from "./add-contact.vue?vue&type=style&index=0&id=72277943&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports